import { ref } from 'vue';
import DateUtility from '../../utilities/dates';

export type EventSlot = {
  startTime: string;
  endTime: string;
  id: string;
};

export const useInterviewBooking = () => {
  const { formatDate } = DateUtility;

  const view = ref<'slots' | 'confirm'>('slots');
  const selectedSlot = ref('');
  const selectedSlotStartTime = ref('');
  const selectedSlotEndTime = ref('');

  const selectSlot = (event: EventSlot) => {
    selectedSlot.value = event.id;
    selectedSlotStartTime.value = event.startTime;
    selectedSlotEndTime.value = event.endTime;
  };

  const openForm = () => {
    view.value = 'confirm';
  };

  const reset = () => {
    view.value = 'slots';
    selectedSlot.value = '';
    selectedSlotStartTime.value = '';
    selectedSlotEndTime.value = '';
  };

  return {
    formatDate,
    view,
    selectedSlot,
    selectedSlotStartTime,
    selectedSlotEndTime,
    selectSlot,
    openForm,
    reset,
  };
};
